import { mtFetch, type FetchResult } from "./mtFetch";
import type { SenseGroupedResponse } from "./types";

export function getAbbreviationsByShort(
  short: string,
): Promise<FetchResult<SenseGroupedResponse>> {
  return mtFetch<SenseGroupedResponse>(
    `/admin/abbreviations-by-short/${encodeURIComponent(short)}`,
  );
}
